import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'

export const CapitalProjectManagement = () => {
  return (
    <MicroFrontEnd
      name="CapitalProjectManagement"
      src={apiConfig.microFrontEnds.CapitalProjectManagement}
    />
  )
}

export default CapitalProjectManagement
